import { Fragment, useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Alert from "../layout/Alert";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createDealerInformation,
  updateDealerInformation,
} from "./../../action/deviceDealer";
import { getCountryCodeISO } from "../../utils/general";
import "./deviceDealersList.css";
import FormInput from "../Common/FormInputs/MuiTextField";
import Button from "../Common/Button/Button";
import MuiIconButton from "../Common/Button/IconButton";
import { Paper } from "@mui/material";
import { selectMenuProps } from "../../utils/selectMenuProps";

const CreateDealer = ({
  allowedCountries,
  setAlert,
  editDeviceDealerDetails,
  deviceDealerDetails,
  cancelEditDeviceDealerDetails,
}) => {
  const dealerPhoneTypeFree = "free";

  const [dealerId, setDealerId] = useState(deviceDealerDetails?.["id"] ?? "");
  const [dealerName, setDealerName] = useState(
    deviceDealerDetails?.["name"] ?? "",
  );
  const [dealerWebsite, setDealerWesbite] = useState(
    deviceDealerDetails?.["webiste"] ?? "",
  );
  const [dealerEmail, setDealerEmail] = useState(
    deviceDealerDetails?.["email"] ?? "",
  );
  const [dealerPhoneNumbers, setDealerPhoneNumbers] = useState([
    {
      //"countryCode": dealerPhoneDefaultCountryCode,
      number: "",
      type: dealerPhoneTypeFree,
    },
  ]);
  const [dealerCountry, setDealerCountry] = useState("");
  const [dealerAddressLine1, setDealerAddressLine1] = useState(
    deviceDealerDetails?.["address"]?.["line1"] ?? "",
  );
  const [dealerAddressLine2, setDealerAddressLine2] = useState(
    deviceDealerDetails?.["address"]?.["line2"] ?? "",
  );
  const [dealerCity, setDealerCity] = useState(
    deviceDealerDetails?.["address"]?.["city"] ?? "",
  );
  const [dealerPincode, setDealerPincode] = useState(
    deviceDealerDetails?.["address"]?.["pin"] ?? "",
  );
  const [dealerSocialFBLink, setDealerSocialFBLink] = useState(
    deviceDealerDetails?.["socials"]?.["facebook"] ?? "",
  );
  const [dealerSocialInstaLink, setDealerSocialInstaLink] = useState(
    deviceDealerDetails?.["socials"]?.["instagram"] ?? "",
  );
  const [dealerSocialXLink, setDealerSocialXLink] = useState(
    deviceDealerDetails?.["socials"]?.["x"] ?? "",
  );

  const [createDealerButtonClicked, setCreateDealerButtonClicked] =
    useState(false);
  const [createDealerInfoInProgress, setCreateDealerInfoInProgress] =
    useState(false);

  useEffect(() => {
    if (createDealerButtonClicked) {
      handleCreateDealer();
    }
  }, [createDealerButtonClicked]);

  useEffect(() => {
    if (
      editDeviceDealerDetails &&
      deviceDealerDetails &&
      Object.keys(deviceDealerDetails).length !== 0
    ) {
      setDealerId(deviceDealerDetails["id"] || "");
      setDealerName(deviceDealerDetails["name"] || "");
      setDealerWesbite(deviceDealerDetails["website"] || "");
      setDealerEmail(deviceDealerDetails["email"] || "");
      setDealerCountry(deviceDealerDetails["country"] || "");
      setDealerAddressLine1(deviceDealerDetails?.["address"]?.["line1"] ?? "");
      setDealerAddressLine2(deviceDealerDetails?.["address"]?.["line2"] ?? "");
      setDealerCity(deviceDealerDetails?.["address"]?.["city"] ?? "");
      setDealerPincode(deviceDealerDetails?.["address"]?.["pin"] ?? "");
      setDealerSocialFBLink(
        deviceDealerDetails?.["socials"]?.["facebook"] ?? "",
      );
      setDealerSocialInstaLink(
        deviceDealerDetails?.["socials"]?.["instagram"] ?? "",
      );
      setDealerSocialXLink(deviceDealerDetails?.["socials"]?.["x"] ?? "");

      // set phone numbers
      let arrPhoneNumbers = [];
      for (let i = 0; i < deviceDealerDetails["phone"].length; i++) {
        arrPhoneNumbers.push({
          //"countryCode": deviceDealerDetails["phone"][i],
          number: deviceDealerDetails["phone"][i]["number"].replace(
            /[+ - e E .]+/g,
            "",
          ),
          type: deviceDealerDetails["phone"][i]["type"],
        });
      }
      setDealerPhoneNumbers(arrPhoneNumbers);
    } else {
      setDealerName("");
      setDealerWesbite("");
      setDealerEmail("");
      setDealerPhoneNumbers([
        {
          //"countryCode": dealerPhoneDefaultCountryCode,
          number: "",
          type: dealerPhoneTypeFree,
        },
      ]);
      setDealerCountry("");
      setDealerAddressLine1("");
      setDealerAddressLine2("");
      setDealerCity("");
      setDealerPincode("");
      setDealerSocialFBLink("");
      setDealerSocialInstaLink("");
      setDealerSocialXLink("");
    }
  }, [editDeviceDealerDetails, deviceDealerDetails]);

  function handleCreateDealer() {
    let bIsUserInputFieldError = false;

    if (!dealerName || dealerName.length === 0) {
      setAlert("Dealer Name Cannot be Empty", "danger");
      bIsUserInputFieldError = true;
    }

    // Website URL is not mandatory.. Hence not checked for emptiness
    if (
      dealerWebsite &&
      (dealerWebsite.match(
        /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi,
      ) === null ||
        dealerWebsite.match(
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
        ) === null)
    ) {
      setAlert("Invalid Dealer Website URL", "danger");
      bIsUserInputFieldError = true;
    }

    // Email is not mandatory
    if (
      dealerEmail &&
      dealerEmail.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      ) === null
    ) {
      setAlert("Invalid Dealer Email ID", "danger");
      bIsUserInputFieldError = true;
    }

    // Phone Number Validation
    for (let index in dealerPhoneNumbers) {
      if (
        !dealerPhoneNumbers[index]["number"] ||
        dealerPhoneNumbers[index]["number"].toString().length === 0
      ) {
        setAlert("Invalid Phone Number Details", "danger");
        bIsUserInputFieldError = true;
        break;
      }
    }

    if (!dealerCountry || dealerCountry.length === 0) {
      setAlert("Invalid Country Name. Cannot be Empty", "danger");
      bIsUserInputFieldError = true;
    }

    if (!dealerAddressLine1 || dealerAddressLine1.length === 0) {
      setAlert("Address Line 1 is Mandatory. Cannot be Empty", "danger");
      bIsUserInputFieldError = true;
    }

    if (!dealerCity || dealerCity.length === 0) {
      setAlert("City is Mandatory. Cannot be Empty", "danger");
      bIsUserInputFieldError = true;
    }

    if (bIsUserInputFieldError) {
      setCreateDealerButtonClicked(false);
      window.scrollTo(0, 0);
      return;
    }

    setCreateDealerInfoInProgress(true);

    let dealerInformation = {};
    dealerInformation["name"] = dealerName;
    dealerInformation["phone"] = dealerPhoneNumbers;
    dealerInformation["country"] = dealerCountry;
    dealerInformation["address"] = {};
    dealerInformation["address"]["line1"] = dealerAddressLine1;
    dealerInformation["address"]["city"] = dealerCity;
    dealerInformation["socials"] = {};

    if (dealerWebsite && dealerWebsite.length > 0) {
      dealerInformation["website"] = dealerWebsite;
    }
    if (dealerEmail && dealerEmail.length > 0) {
      dealerInformation["email"] = dealerEmail;
    }
    if (dealerAddressLine2 && dealerAddressLine2.length > 0) {
      dealerInformation["address"]["line2"] = dealerAddressLine2;
    }
    if (dealerPincode && dealerPincode.length > 0) {
      dealerInformation["address"]["pin"] = parseInt(dealerPincode);
    }
    if (dealerSocialFBLink && dealerSocialFBLink.length > 0) {
      dealerInformation["socials"]["facebook"] = dealerSocialFBLink;
    }
    if (dealerSocialInstaLink && dealerSocialInstaLink.length > 0) {
      dealerInformation["socials"]["instagram"] = dealerSocialInstaLink;
    }
    if (dealerSocialXLink && dealerSocialXLink.length > 0) {
      dealerInformation["socials"]["x"] = dealerSocialXLink;
    }

    if (editDeviceDealerDetails) {
      updateDealerInformation(dealerId, dealerInformation)
        .then(() => {
          setAlert("Dealer Updated Successfully", "success");
          window.scrollTo(0, 0);

          setCreateDealerInfoInProgress(false);
          setCreateDealerButtonClicked(false);

          // go back to the details page after update
          cancelEditDeviceDealerDetails();
        })
        .catch((err) => {
          setAlert(
            err?.response?.data?.message ?? "Failed to Update Device Dealer",
            "danger",
          );
          window.scrollTo(0, 0);

          setCreateDealerInfoInProgress(false);
          setCreateDealerButtonClicked(false);
        });
    } else {
      createDealerInformation(dealerInformation)
        .then(() => {
          setAlert("Dealer Created Successfully", "success");
          window.scrollTo(0, 0);

          setCreateDealerInfoInProgress(false);
          setCreateDealerButtonClicked(false);
        })
        .catch((err) => {
          setAlert(
            err?.response?.data?.message ?? "Failed to Create Device Dealer",
            "danger",
          );
          window.scrollTo(0, 0);

          setCreateDealerInfoInProgress(false);
          setCreateDealerButtonClicked(false);
        });
    }
  }

  function handleDealerDataReset() {
    setDealerName("");
    setDealerWesbite("");
    setDealerEmail("");
    setDealerPhoneNumbers([
      {
        //"countryCode": dealerPhoneDefaultCountryCode,
        number: "",
        type: dealerPhoneTypeFree,
      },
    ]);
    setDealerAddressLine1("");
    setDealerAddressLine2("");
    setDealerCity("");
    setDealerPincode("");
    setDealerSocialFBLink("");
    setDealerSocialInstaLink("");
    setDealerSocialXLink("");
    setCreateDealerButtonClicked(false);
    setCreateDealerInfoInProgress(false);
  }

  function handleAddDealerPhoneNumber() {
    let updatedDealerPhoneNumbers = [...dealerPhoneNumbers];
    updatedDealerPhoneNumbers.push({
      //"countryCode": dealerPhoneDefaultCountryCode,
      number: "",
      type: dealerPhoneTypeFree,
    });

    setDealerPhoneNumbers(updatedDealerPhoneNumbers);
  }

  function onChangeDealerPhoneNumber(value, index) {
    let elements = [...dealerPhoneNumbers];
    elements[index]["number"] = value;

    setDealerPhoneNumbers(elements);
  }

  function onChangeDealerPhoneNumberType(value, index) {
    let elements = [...dealerPhoneNumbers];
    elements[index]["type"] = value;

    setDealerPhoneNumbers(elements);
  }

  function onDeleteDealerPhoneNumber(indexToDelete) {
    let updatedDealerPhoneNumbers = dealerPhoneNumbers.filter(
      (element, index) => {
        return index !== indexToDelete;
      },
    );

    setDealerPhoneNumbers(updatedDealerPhoneNumbers);
  }

  const layout12644 = { xs: 12, sm: 6, md: 4, lg: 4 };
  const layout12444 = { xs: 12, sm: 4, md: 4, lg: 4 };

  return (
    <Fragment>
      <Paper
        elevation={3}
        sx={{
          mt: 0,
          p: { xs: 2, md: 3 },
          borderRadius: 2,
        }}
      >
        <Alert />

        <Grid container spacing={3}>
          <Grid size={layout12644}>
            <FormInput
              name="dealerName"
              label="Name *"
              placeholder="Enter Your Name"
              value={dealerName}
              onChange={(e) => setDealerName(e.target.value)}
            />
          </Grid>

          <Grid size={layout12644}>
            <FormInput
              name="dealerWebsite"
              placeholder="Enter Your Website URL"
              label="Website"
              value={dealerWebsite}
              onChange={(e) => setDealerWesbite(e.target.value)}
            />
          </Grid>

          <Grid size={layout12644}>
            <FormInput
              name="dealerEmailId"
              type="email"
              placeholder="Enter Your Email ID"
              label="Email ID"
              value={dealerEmail}
              onChange={(e) => setDealerEmail(e.target.value)}
            />
          </Grid>
          <Grid
            size={{ xs: 0, sm: 6, md: 0, lg: 0 }}
            sx={{
              display: { xs: "none", sm: "block", md: "none", lg: "none" },
            }}
          />

          <Grid size={layout12444}>
            <FormInput
              name="dealerPhoneNumber"
              type="number"
              placeholder="Enter Your Phone Number"
              label="Phone *"
              value={dealerPhoneNumbers[0].number}
              onChange={(e) => onChangeDealerPhoneNumber(e.target.value, 0)}
              onKeyDown={(e) => {
                ["e", "E", "-", "+", "."].includes(e.key) && e.preventDefault();
              }}
            />
          </Grid>

          <Grid size={layout12444}>
            <FormInput
              name="dealerPhoneNumberType"
              type="select"
              label="Phone Type"
              value={dealerPhoneNumbers[0].type}
              onChange={(e) => onChangeDealerPhoneNumberType(e.target.value, 0)}
              options={[
                { label: "Free", value: "free" },
                { label: "Paid", value: "paid" },
              ]}
              MenuProps={selectMenuProps}
            />
          </Grid>

          <Grid size={layout12444}>
            <Button onClick={handleAddDealerPhoneNumber}>
              Add Phone Number
            </Button>
          </Grid>

          {dealerPhoneNumbers &&
            dealerPhoneNumbers.length > 1 &&
            dealerPhoneNumbers.slice(1).map((element, index) => {
              return (
                <Fragment key={index}>
                  <Grid size={layout12444}>
                    <FormInput
                      name="dealerPhoneNumber"
                      type="number"
                      placeholder="Enter Your Phone Number"
                      label="Phone"
                      value={element.number}
                      onChange={(e) =>
                        onChangeDealerPhoneNumber(e.target.value, index + 1)
                      }
                      onKeyDown={(e) => {
                        ["e", "E", "+", "-", "."].includes(e.key) &&
                          e.preventDefault();
                      }}
                    />
                  </Grid>

                  <Grid size={layout12444}>
                    <FormInput
                      name="dealerPhoneNumberType"
                      type="select"
                      label="Phone Type"
                      value={element.type}
                      onChange={(e) =>
                        onChangeDealerPhoneNumberType(e.target.value, index + 1)
                      }
                      options={[
                        { label: "Free", value: "free" },
                        { label: "Paid", value: "paid" },
                      ]}
                      MenuProps={selectMenuProps}
                    />
                  </Grid>

                  <Grid size={layout12444}>
                    <MuiIconButton
                      icon={<DeleteIcon />}
                      variant="danger"
                      onClick={() => onDeleteDealerPhoneNumber(index + 1)}
                    />
                  </Grid>
                </Fragment>
              );
            })}

          <Grid size={layout12444}>
            <FormInput
              name="dealerCountry"
              type="select"
              label="Country *"
              value={dealerCountry}
              onChange={(e) => setDealerCountry(e.target.value)}
              options={allowedCountries
                .filter((c) => getCountryCodeISO(c.toUpperCase()))
                .map((c) => {
                  const code = getCountryCodeISO(c.toUpperCase());
                  return { label: code, value: code };
                })}
              MenuProps={selectMenuProps}
            />
          </Grid>

          <Grid size={layout12444}>
            <FormInput
              name="dealerCity"
              placeholder="Enter Your City"
              label="City *"
              value={dealerCity}
              onChange={(e) => setDealerCity(e.target.value)}
              onKeyDown={(e) => {
                if (!e.key.match(/^[A-Za-z]+$/)) e.preventDefault();
              }}
            />
          </Grid>

          <Grid size={layout12444}>
            <FormInput
              name="dealerPincode"
              placeholder="Enter Your Pincode"
              type="number"
              label="Pincode"
              value={dealerPincode}
              onChange={(e) => setDealerPincode(e.target.value)}
              onKeyDown={(e) => {
                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault();
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <FormInput
              name="dealerAddress1"
              placeholder="Enter Line 1 Address"
              label="Address Line 1 *"
              value={dealerAddressLine1}
              onChange={(e) => setDealerAddressLine1(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <FormInput
              name="dealerAddress2"
              placeholder="Enter Line 2 Address"
              label="Address Line 2"
              value={dealerAddressLine2}
              onChange={(e) => setDealerAddressLine2(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <FormInput
              name="dealerFbId"
              placeholder="Enter Your Facebook Id"
              label="Facebook"
              value={dealerSocialFBLink}
              onChange={(e) => setDealerSocialFBLink(e.target.value)}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <FormInput
              name="dealerInstaId"
              placeholder="Enter Your Instagram Id"
              label="Instagram"
              value={dealerSocialInstaLink}
              onChange={(e) => setDealerSocialInstaLink(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
            <FormInput
              name="dealerXId"
              placeholder="Enter Your X Id"
              label="X"
              value={dealerSocialXLink}
              onChange={(e) => setDealerSocialXLink(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12 }} sx={{ mt: 1 }} display="flex" gap={2}>
            <Button
              loading={createDealerInfoInProgress}
              onClick={() => setCreateDealerButtonClicked(true)}
            >
              {editDeviceDealerDetails ? "Update Dealer" : "Create Dealer"}
            </Button>

            {editDeviceDealerDetails ? (
              <Button variant="ghost" onClick={cancelEditDeviceDealerDetails}>
                Cancel
              </Button>
            ) : (
              <Button variant="ghost" onClick={handleDealerDataReset}>
                Reset
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
};

export default CreateDealer;
